
export abstract class SmartTableData {
  abstract getData(): any[];
  abstract get1Data(): any[];
}
